import Block from '@blocks/index'
import Layout from '@components/Layout'
import NewsletterBreaker from '@components/NewsletterBreaker'
import NewsletterCard from '@components/NewsletterCard'
import Seo from '@components/Seo'
import { getStaticPage, queries } from '@data/index'
import { useAppContext } from '@hooks/useAppContext'
import { usePageType } from '@state/store'
import Error from 'next/error'
import { useEffect } from 'react'

import styles from './Newsletters.module.scss'

const Newsletters = ({ data }) => {
  const { page } = data
  const pageType = usePageType()

  const { globals } = useAppContext()
  const site = globals.site

  const { title, seoContent, pageBuilder } = page || {}
  const { seoTitle, seoDescription, seoImage } = seoContent || {}

  const recentNewsletters = site.recents.newsletters

  useEffect(() => {
    pageType.setPageType('newsletters')
  }, [pageType])

  if (!page) {
    return (
      <Error
        title={`"Newsletters Page" is not set in Sanity, or the page data is missing`}
        statusCode="Data Error"
      />
    )
  }

  return (
    <>
      <Seo
        title={seoTitle ? seoTitle : title}
        description={seoDescription ? seoDescription : null}
        image={seoImage ? seoImage : null}
        site={site}
      />
      <Layout>
        <>
          <div>
            {pageBuilder?.map((block, key) => (
              <Block key={key} index={key} block={block} site={site} />
            ))}
          </div>

          <div className={styles.wrapper}>
            <div className={styles.container}>
              <div className={styles.inner}>
                <div className={styles.list}>
                  {recentNewsletters.map((n, i) => {
                    return <NewsletterCard key={i} data={n} />
                  })}
                </div>
                <div className={styles.sidebar}>
                  <div className={styles.stick}>
                    <NewsletterBreaker />
                    <NewsletterHighlights data={recentNewsletters} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      </Layout>
    </>
  )
}

export async function getStaticProps({ preview, previewData }) {
  const pageData = await getStaticPage(
    `"page": *[_type == "pageSettings"][0].newsletterPage->{
      title,
      altPageTitle,
      seoContent,
      pageBuilder[]{
        ${queries.builderQueries}
      }
    }`,
    {
      active: preview,
      token: previewData?.token,
    }
  )

  // append all the newsletters to the rss feed
  // generateRSSFeed(articles)

  return {
    props: {
      data: pageData,
    },
  }
}

export default Newsletters

const NewsletterHighlights = ({ data }) => {
  return (
    <div className="hidden lg:block">
      <h5 className="font-bold text-[22px] m-0 mb-8 p-0">
        Newsletter Highlights
      </h5>

      {data.map((n, i) => {
        return <NewsletterCard key={i} data={n} noImage noExcerpt />
      })}
    </div>
  )
}
